import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useParams } from "react-router-dom";
import Layout from "./layouts/sidebar";
import GetStarted from "./pages/getStart";
import Authentication from "./pages/authentication";
import RequestEncryption from "./pages/requestEncryption";
import DynamicPageGenerator from "./components/dynamicPageGenerater";
import { AuthProvider, useAuth } from "./providers/AuthProvider";
import Swagger from "pages/swagger";
import WooCommerce from "pages/plugins/wooCommerce";
import CustomPayment from "pages/customPayment";
import RefundRequest from "components/request-pages/refundRequest";

function DynamicPage() {
  const { pageName } = useParams();
  
  // Define a mapping of paths to components
  const pageComponents = {
    [pageName]: <DynamicPageGenerator pageName={pageName}/>,
  };

  return pageComponents[pageName] || "Page Not Found..."; // Show NotFound if the page doesn't exist
}

function AppContent() {
  const { authToken } = useAuth();

  // useEffect(() => {
  //     setupAxiosInterceptors  (authToken);
  // }, [authToken]);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<GetStarted />} />
          <Route path="/getStart" element={<GetStarted />} />
          <Route path="/authentication" element={<Authentication />} />
          <Route path="/swagger" element={<Swagger />} />
          <Route path="/woocommerce" element={<WooCommerce/>} />
          <Route path="/customPayment" element={<CustomPayment/>} />
          <Route path="/refundRequest" element={<RefundRequest/>} />
          <Route path="/encryption" element={<RequestEncryption />} />

          {/* Dynamic Route */}
          <Route path="/:pageName" element={<DynamicPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

function App() {
  return (
      <AuthProvider>
          <AppContent />
      </AuthProvider>
  );
}

export default App;

